export const GET_SURVEY_LIST='GET_SURVEY_LIST';
export const GET_SURVEY_DEFINITION_BY_ID='GET_SURVEY_DEFINITION_BY_ID';
export const ON_EDIT_SURVEY_CHANGE='ON_EDIT_SURVEY_CHANGE';



